import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Row
} from 'react-bootstrap';
import {
  compose,
  setPropTypes,
  renderComponent,
  branch
} from 'recompose';
import {
  FormField
} from '../../components';
import Loading from '../../pages/loading';
import {
  dateFormats,
  months
} from '../../../constants';
import {
  noCapMap
} from '../../../utils';

const CpdAnniversarySetting = ({
  cpdDate,
  onIndustryDateChange,
  planLocked
}) => (
    <Row className='no-gutter'>
      <Col xs={10} xsOffset={1} sm={4} smOffset={1}>
        <FormField id='cpd-day' type='select-item' label='Day'>
          <select
            id='cpd-day'
            value={dateFnsCompat.getDate(cpdDate)}
            disabled={planLocked}
            onChange={(e) => onIndustryDateChange(dateFnsCompat.setDate(cpdDate, parseInt(e.target.value, 10)))}>
            {
              fp.flow(
                fp.spread(fp.range),
                fp.map((day) =>
                  <option key={day} value={day}>
                    {day}
                  </option>
                )
              )([1, dateFnsCompat.getDaysInMonth(cpdDate) + 1])
            }
          </select>
        </FormField>
      </Col>
      <Col xs={10} xsOffset={1} sm={4} smOffset={2}>
        <FormField id='cpd-month' type='select-item' label='Month'>
          <select
            id='cpd-month'
            value={dateFnsCompat.getMonth(cpdDate) + 1}
            disabled={planLocked}
            onChange={(e) => onIndustryDateChange(dateFnsCompat.setMonth(cpdDate, parseInt(e.target.value, 10) - 1))}>
            {
              fp.flow(
                fp.values,
                noCapMap(
                  (month, index) => (
                    <option key={month} value={index + 1}>
                      {month}
                    </option>
                  )
                )
              )(months)
            }
          </select>
        </FormField>
      </Col>
      <Col xs={12}>
        <div className='form-horizontal'>
          <div className='form-group'>
            <Col componentClass='label' sm={6} className='control-label'>
              CPD year end date
            </Col>
            <Col sm={6}>
              <p className='form-control-static'>
                {dateFnsCompat.format(cpdDate, dateFormats.LongDate)}
              </p>
            </Col>
          </div>
        </div>
      </Col>
    </Row>
  );

export default compose(
  setPropTypes({
    isLoading: PropTypes.bool,
    cpdDate: PropTypes.object,
    onIndustryDateChange: PropTypes.func,
    planLocked: PropTypes.bool
  }),
  branch(
    ({ isLoading }) => isLoading,
    renderComponent(Loading)
  )
)(CpdAnniversarySetting);



// WEBPACK FOOTER //
// ./src/containers/partials/cpd-settings/cpd-anniversary-setting.js